import { render, staticRenderFns } from "./P2PArbitratorsList.vue?vue&type=template&id=09813d37&scoped=true&"
import script from "./P2PArbitratorsList.vue?vue&type=script&lang=js&"
export * from "./P2PArbitratorsList.vue?vue&type=script&lang=js&"
import style0 from "./P2PArbitratorsList.vue?vue&type=style&index=0&id=09813d37&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09813d37",
  null
  
)

export default component.exports